import { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'

import { excludeNullAndUndefined } from '../utils/excludeNullAndUndefined'
import { resolveSegment } from './resolveSegment'

export const createMetadataFromBusinessTerm = (businessTerm: BusinessTerm, businessSegmentId?: string) => {
  const {
    industryId,
    structureId,
    segmentationIndustryId,
    businessType,
    postRegVertical,
    // linebreak keeper
  } = businessTerm || {}

  const { segment, subSegment } = resolveSegment({ structureId })

  return excludeNullAndUndefined({
    structureId,
    industryId,
    segmentationIndustryId,
    businessType,
    postRegVertical,
    segment,
    subSegment,
    businessSegmentId,
  })
}
